<template>
  <div>
    <el-form :model="modelValue" ref="dynamicContent">
      <el-row
        v-for="(source, index) in modelValue.content_fetch_sources"
        :key="index"
        :model="source"
      >
        <el-col :span="3">
          <form-item
            :label="$t('CampaignForm_Setup_Format')"
            :prop="'content_fetch_sources.' + index + '.format'"
            :rules="rules.format"
          >
            <el-select v-model="source.format">
              <el-option
                v-for="item in format"
                :key="item.value"
                :value="item.value"
                :label="$t(item.label)"
              />
            </el-select>
          </form-item>
        </el-col>
        <el-col :span="isProxyEnabled ? 14 : 16">
          <form-item
            :label="$t('CampaignForm_Setup_Url')"
            :prop="'content_fetch_sources.' + index + '.url'"
            :rules="rules.url"
            :hint="showHint(source.url)"
          >
            <el-input v-model="source.url" />
          </form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            class="namespace"
            :label="$t('CampaignForm_Setup_Namespace')"
            :prop="'content_fetch_sources.' + index + '.namespace'"
            :rules="rules.namespace"
          >
            <el-input v-model="source.namespace"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" v-if="isProxyEnabled">
          <el-form-item
            class="static-ip"
            :label="$t('CampaignForm_Setup_UseStaticIP')"
          >
            <el-switch v-model="source.use_static_ip"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <form-item label=" ">
            <el-button
              class="delete-button"
              type="primary"
              @click="removeSource(index)"
              plain
              icon="el-icon-delete"
            />
          </form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="p-top-20">
      <el-button
        type="primary"
        @click="addSource"
        plain
        icon="el-icon-circle-plus-outline"
      >
        {{ $t('CampaignForm_Setup_Button_AddSource') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import store from '@/core/store'
export default {
  name: 'FetchDynamicContent',
  components: { FormItem },
  data() {
    return {
      row: { format: 'json', url: '', namespace: '', use_static_ip: false },
      format: [
        { value: 'json', label: 'CampaignForm_Setup_Format_Json' },
        { value: 'xml', label: 'CampaignForm_Setup_Format_Xml' }
      ],
      rules: {
        format: { type: 'string', required: true },
        url: [
          {
            required: true,
            message: this.$t('CampaignForm_Setup_Message_UrlIsRequired'),
            trigger: 'blur'
          },
          {
            type: 'url',
            message: this.$t('CampaignForm_Setup_Message_UrlIsNotValid'),
            trigger: 'blur'
          }
        ],
        namespace: { type: 'string', required: false }
      }
    }
  },
  methods: {
    addSource() {
      this.modelValue.content_fetch_sources.push({ ...this.row })
    },
    removeSource(key) {
      this.modelValue.content_fetch_sources.splice(key, 1)
    },
    showHint(url) {
      return RegExp('{{.+}}').test(url)
        ? this.$t('CampaignForm_Setup_FetchPersonalizationHint')
        : ''
    }
  },
  props: {
    value: {
      required: true
    }
  },
  computed: {
    isProxyEnabled() {
      return store.state.app.proxy ? store.state.app.proxy['enabled'] : null
    },
    modelValue: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.delete-button {
  padding: 12px 8px;
  width: 50px;
}
.namespace {
  width: 100%;
  padding-right: 10px;
}
.static-ip {
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/FetchDynamicContent.vue